<template>
  <div id="chat">
    <div v-if="loading"></div>
    <div v-else>
      <div style="position:relative">
        <header>
          <nav id="header" ref="header">
            <div class="row">
              <div class="col-xs-3" @click="openSidebar">
                <div style="padding: 13px 10px;">
                  <span class="glyphicon glyphicon-chevron-left"></span>
                </div>
              </div>
              <div class="col-xs-6 text-center">
                <div style="padding: 13px 0px">{{ displayName }}</div>
              </div>
              <div class="col-xs-3 text-right">
                <!-- <div style="padding: 10px;"><span class="glyphicon glyphicon-option-horizontal"></span></div> -->
              </div>
            </div>
          </nav>
        </header>

        <div style="position:relative;height: 100vh;background: #7991bd; overflow: hidden">
          <div
            ref="chatlogContainer"
            style="overflow-y: auto;overflow-x: hidden;position:relative;width: 100%"
            :style="{ height: chatlogHeight + 'px' }"
            @scroll="scrollChatlog"
          >
            <div
              v-if="isLoadmore && ableToLoadmore"
              style="background: white;text-align: center;padding: 10px 0px;margin-bottom: 10px"
              :style="{ 'padding-top': headerHeight + 6 + 'px' }"
            >
              Loading...
            </div>
            <div ref="padding" v-else :style="{ height: headerHeight + 6 + 'px' }"></div>
            <div ref="chatlog" style="padding: 5px">
              <div
                v-for="(message, index) in messages"
                :key="'message_' + message.id + '_' + index"
                v-if="message.messagedata != '' && message.messagedata != null"
              >
                <!-- {{message.messagedata}}
                                {{message.messagetype}} -->
                <div
                  v-if="message.answerby == 'admin' || message.answerby == 'bot'"
                  style="overflow: auto"
                >
                  <template v-if="message.messagetype == 'text'">
                    <message-viewer
                      v-model="message.messagedata"
                      color="black"
                      background="#9adf60"
                      style="float: right"
                    ></message-viewer>
                  </template>
                  <template v-else-if="message.messagetype == 'template'">
                    <generic-viewer
                      size="small"
                      v-model="message.messagedata"
                      style="float: right"
                    ></generic-viewer>
                  </template>
                </div>
                <div v-else style="overflow: auto">
                  <div style="overflow: auto;">
                    <img
                      :src="message.profile_pic"
                      alt=""
                      style="width: 28px; height: 28px;border: 1px solid #eee;border-radius: 50%; float: left;margin-right: 5px;"
                    />
                    <template v-if="message.messagetype == 'text'">
                      <message-viewer
                        v-model="message.messagedata"
                        style="float: left"
                      ></message-viewer>
                    </template>
                    <template v-else-if="message.messagetype == 'template'">
                      <generic-viewer
                        size="small"
                        v-model="message.messagedata"
                        style="float: left"
                      ></generic-viewer>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isBottom && ableToScroll"
            id="goBottom"
            style="position: fixed;bottom: 60px;right: 15px;background: white;font-size: 17px;padding: 4px 6px 1px 6px;border-radius: 5px;box-shadow: 0px 4px 5px #00000057;pointer: cursor; border: 1px solid #eee"
            @click="scrollBottom"
          >
            <span class="glyphicon glyphicon-arrow-down"></span>
          </div>
        </div>

        <div
          ref="sendContainer"
          style="width: 100%;background: #ffffff;padding: 5px;overflow: auto;border-top: 1px solid #eee;position: fixed;bottom: 0"
        >
          <div ref="toolBtn" style="float: left;">
            <!-- margin-top: 5px;margin-right: 10px;margin-left: 5px; -->
            <!-- <a href="javascript:void(0)" style="font-size: 20px;margin-right: 10px"><span class="glyphicon glyphicon-picture"></span></a>
                        <a href="javascript:void(0)" style="font-size: 20px"><span class="glyphicon glyphicon-adjust"></span></a> -->
          </div>
          <div
            v-if="messageInputWidth"
            ref="messageInput"
            id="messageInput"
            style="border: 1px solid #d8d9de;background: #f7f7f7;border-radius: 15px;overflow: hidden;padding: 5px; float: left"
            :style="{ width: messageInputWidth + 'px' }"
          >
            <autoresize-textarea
              v-model="text"
              rows="1"
              placeholder="Type message"
              style="resize: none;border: 0px; outline: 0px;width: 100%;background: none"
              @focus="onTyping"
            ></autoresize-textarea>
          </div>
          <div ref="sendBtn" style="margin-top: 5px;margin-left: 5px;float: left;">
            <a href="javascript:void(0)" style="font-size: 20px" @click="sendMessage"
              ><span class="glyphicon glyphicon-send"></span
            ></a>
          </div>
        </div>

        <div
          ref="sidebarContainer"
          style="left: 0px;top: 0px;height: 100%;max-height: 100vh;background: #585858;width: 100%;margin: 0;z-index: 1000;position: absolute;overflow-x: hidden;overflow-y: hidden; "
          :style="{ 'margin-left': showSidebar ? '0px' : '-10000px' }"
        >
          <div ref="sidebarHeader">
            <div class="row">
              <div class="col-xs-3"></div>
              <div class="col-xs-6 text-center">
                <img src="/static/img/logo-small.png" alt="" style="width:60px;margin: 15px" />
              </div>
              <div class="col-xs-3 text-right" style="padding-top: 10px;">
                <!-- <a href="javascript:void(0)" style="font-size: 20px;padding: 10px;" @click="showSidebar = false"><span class="glyphicon glyphicon-remove"></span></a> -->
              </div>
            </div>
            <!-- <div style="padding: 0 10px 10px 10px;border-bottom: 1px solid #737373;">
                            <div style="border: 1px solid #eee; border-radius: 20px;padding: 2px 10px; overflow: hidden;background: white;">
                                <input type="text" id="search" placeholder="Search" style="border: none; outline: none; background: none;width: 100%">
                            </div>
                        </div> -->
            <div style="overflow: auto;border-top: 1px solid #848484">
              <div
                class="channel"
                :class="{ active: app == 'facebook' }"
                @click="changeChannel('facebook')"
                style="border-right: 1px solid #848484"
              >
                <img src="/static/img/assets/logo/icon-facebook.png" alt="facebook" />
              </div>
              <div
                class="channel"
                :class="{ active: app == 'line' }"
                @click="changeChannel('line')"
              >
                <img src="/static/img/assets/logo/icon-line.png" alt="line" />
              </div>
            </div>
          </div>
          <div
            ref="sidebarContact"
            class="users-list"
            v-if="sidebarContactHeight"
            :style="{ height: sidebarContactHeight + 'px' }"
            @scroll="scrollUsers"
          >
            <div ref="contact">
              <div
                class="user"
                @click="onSelectUser(user)"
                v-for="(user, index) in sortedUsers"
                :key="'user_' + index"
              >
                <div style="float: left;margin-right: 5px;">
                  <img
                    :src="user.profile_pic"
                    alt=""
                    style="width:50px;height: 50px; border-radius: 50%;"
                    @error="imgError"
                  />
                </div>
                <div style="float: left;padding-left: 5px;">
                  <p style="margin: 0; margin-top: 10px;">
                    {{ user.first_name + ' ' + user.last_name }}
                    <span class="badge" v-if="checkingUsers[user.userid].haveNewMessage">New</span>
                  </p>
                  <span style="font-size: 9px;color: #adabab">{{
                    user.lastreply_time | DateDistance
                  }}</span>
                </div>
              </div>

              <div
                v-if="isUserLoadmore && ableToUserLoadmore"
                style="background: white;text-align: center;padding: 10px 0px;margin-bottom: 10px"
              >
                Loading...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import api from '@/api'
import { setInterval, clearInterval } from 'timers'

export default {
  data: function() {
    return {
      userid: undefined,
      pageid: undefined,
      adminid: undefined,
      displayName: undefined,

      messageInputWidth: undefined,
      sidebarContactHeight: undefined,
      chatlogHeight: undefined,
      window: {
        width: undefined,
        height: undefined
      },
      headerHeight: undefined,

      app: 'facebook',

      showSidebar: false,
      text: '',
      messages: [],
      users: [],
      checkingUsers: {},
      loading: true,

      isBottom: true,
      isTop: false,

      isUserBottom: false,
      isUserTop: true,

      refreshingTime: 5000,
      refreshMessages: null,
      refreshUsers: null,

      limit: 200,

      ableToLoadmore: true,
      ableToUserLoadmore: true,

      isLoadmore: false,
      isUserLoadmore: false,

      offsetLoadmore: 200,
      offsetUserLoadmore: 200,

      isSelecting: false,
      ableToScroll: false
    }
  },
  components: {
    AutoresizeTextarea,
    IntentGetstarted,
    GenericViewer,
    MessageViewer
  },
  computed: {
    sortedUsers: function() {
      return this.users.sort(function(a, b) {
        return new Date(b.lastreply_time) - new Date(a.lastreply_time)
      })
    }
  },
  mounted: function() {
    var vm = this

    if (process.env.NODE_ENV === 'development') {
      vm.adminid = 'U7afdc9033c8ed7df350b189ff1a2e899'
      vm.pageid = '844584862409516'
      vm.userid = 'U7afdc9033c8ed7df350b189ff1a2e899__844584862409516'

      vm.getChatUsers(0, function(users) {
        vm.users = users
        for (let index = 0; index < users.length; index++) {
          vm.checkingUsers[users[index].userid] = users[index]
          vm.checkingUsers[users[index].userid].haveNewMessage = false
        }

        setTimeout(() => {
          vm.onRefreshUsers()
        }, vm.refreshingTime)
      })

      vm.getChatlog(0, function(messages) {
        vm.messages = messages
        $.each(vm.messages, function(index, message) {
          if (message.answerby == '') {
            vm.displayName = message.first_name
            return false
          }
        })

        vm.scrollBottom()

        setTimeout(() => {
          vm.onRefreshMessages()
        }, vm.refreshingTime)
      })
      vm.loading = false
      vm.updateLayout()
    } else {
      vm.$store.dispatch('loading')
      liff.init(
        data => {
          liff
            .getProfile()
            .then(profile => {
              // vm.display_name = profile.displayName;
            })
            .catch(err => {
              vm.line_error = true
              setTimeout(() => {
                vm.loading = false
              }, 1000)
            })

          vm.adminid = data.context.userId
          // vm.adminid = 'U7afdc9033c8ed7df350b189ff1a2e899'
          if (vm.$route.query.pageid) {
            vm.pageid = vm.$route.query.pageid
            vm.getChatUsers(0, function(users) {
              vm.users = users
              for (let index = 0; index < users.length; index++) {
                vm.checkingUsers[users[index].userid] = users[index]
                vm.checkingUsers[users[index].userid].haveNewMessage = false
              }

              if (vm.$route.query.userid) {
                vm.userid = vm.$route.query.userid
                vm.getChatlog(0, function(messages) {
                  vm.messages = messages
                  $.each(vm.messages, function(index, message) {
                    if (message.answerby == '') {
                      vm.displayName = message.first_name
                      return false
                    }
                  })

                  vm.scrollBottom()

                  setTimeout(() => {
                    vm.onRefreshMessages()
                  }, vm.refreshingTime)
                })
                vm.$store.dispatch('loading')
              } else {
                vm.$store.dispatch('loading')
                vm.showSidebar = true
              }
              vm.loading = false
              vm.updateLayout()

              setTimeout(() => {
                vm.onRefreshUsers()
              }, vm.refreshingTime)
            })
          }
        },
        err => {
          vm.line_error = true
          setTimeout(() => {
            vm.loading = false
          }, 1000)
          vm.$store.dispatch('loading')
        }
      )
    }
  },
  methods: {
    updateLayout: function() {
      var vm = this
      vm.$nextTick(function() {
        vm.handleResize()
        window.addEventListener('resize', vm.handleResize)
      })
    },
    handleResize: function(event) {
      var vm = this
      vm.headerHeight = vm.$refs.header.offsetHeight
      vm.window.width = window.innerWidth
      vm.window.height = window.innerHeight
      vm.messageInputWidth = vm.getMessageInputWidth()
      vm.chatlogHeight = vm.getChatlogHeight()
      vm.sidebarContactHeight = vm.getSidebarContactHeight()
    },
    getChatlogHeight: function() {
      var vm = this
      return vm.window.height - vm.$refs.sendContainer.offsetHeight - 7
    },
    getMessageInputWidth: function() {
      var vm = this
      return (
        vm.$refs.sendContainer.offsetWidth -
        vm.$refs.sendBtn.offsetWidth -
        vm.$refs.toolBtn.offsetWidth -
        35
      ) //60
    },
    getSidebarContactHeight: function() {
      var vm = this
      return vm.$refs.sidebarContainer.offsetHeight - vm.$refs.sidebarHeader.offsetHeight
    },
    getChatUsers: function(offset, callback) {
      var vm = this

      var data = {
        pageid: vm.pageid,
        app: vm.app,
        type: 'bot',
        limit: vm.limit,
        offset: offset
      }

      api.getChatUsersLine(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        var users = []
        if (response.data) {
          users = response.data
        }
        callback(users)
      })
    },
    sendMessage: function() {
      var vm = this

      var data = {
        id: null,
        pageid: vm.pageid,
        userid: vm.userid,
        adminid: vm.adminid,
        messagetype: 'text',
        messagedata: vm.text,
        timestamp: new Date(),
        answerby: 'admin',
        intent: null,
        profile_pic: null,
        first_name: null,
        messagevalue: vm.text
      }

      vm.messages.push(data)
      vm.scrollBottom()

      vm.text = ''

      api.sendMessageLine(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    },
    onRefreshMessages: function() {
      var vm = this
      vm.refreshMessages = setInterval(function() {
        if (!vm.isBottom && vm.ableToScroll) {
          return false
        }
        vm.getChatlog(0, function(messages) {
          vm.messages = messages
          vm.scrollBottom()
        })
      }, vm.refreshingTime)
    },
    onRefreshUsers: function() {
      var vm = this
      vm.refreshUsers = setInterval(function() {
        if (!vm.isUserTop) {
          return false
        }
        vm.getChatUsers(0, function(users) {
          vm.users = users
          for (let index = 0; index < users.length; index++) {
            var isChange =
              vm.checkingUsers[users[index].userid].lastreply_time != users[index].lastreply_time
            vm.checkingUsers[users[index].userid] = users[index]
            if (isChange) {
              vm.checkingUsers[users[index].userid].haveNewMessage = isChange
            }
          }
          vm.$refs.sidebarContact.scrollTop = 0
        })
      }, vm.refreshingTime)
    },
    onSelectUser: function(user) {
      var vm = this
      vm.isSelecting = true
      vm.userid = user.userid
      vm.displayName = user.first_name
      vm.messages = []
      clearInterval(vm.refreshMessages)
      vm.$store.dispatch('loading')
      vm.getChatlog(0, function(messages) {
        $.each(messages, function(index, message) {
          vm.messages.push(message)
        })
        vm.$store.dispatch('loading')
        vm.showSidebar = false

        vm.scrollBottom()
        vm.isSelecting = false
        setTimeout(() => {
          vm.onRefreshMessages()
        }, vm.refreshingTime)
      })
    },
    getChatlog: function(offset, callback) {
      var vm = this
      var data = {
        userid: this.userid,
        adminid: this.adminid,
        pageid: this.pageid,
        limit: this.limit,
        offset: offset
      }
      api.getChatlogLine(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        var messages = []
        if (response.data) {
          $.each(response.data, function(index, message) {
            if (message.messagetype == 'template') {
              if (vm.isJsonParseable(message.messagedata)) {
                response.data[index].messagedata = JSON.parse(message.messagedata)
              } else {
                response.data[index].messagetype = 'text'
              }
            }

            messages.unshift(response.data[index])
          })
        }
        callback(messages)
      })
    },
    scrollBottom: function() {
      var vm = this
      vm.$nextTick(function() {
        vm.$refs.chatlogContainer.scrollTop = vm.$refs.chatlog.scrollHeight
      })
    },

    imgError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
      // this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    },
    changeChannel: function(channel) {
      var vm = this
      vm.app = channel
      vm.users = []
      clearInterval(vm.refreshUsers)
      vm.$store.dispatch('loading')
      vm.getChatUsers(0, function(users) {
        vm.users = users
        for (let index = 0; index < users.length; index++) {
          vm.checkingUsers[users[index].userid] = users[index]
          vm.checkingUsers[users[index].userid].haveNewMessage = false
        }
        vm.$store.dispatch('loading')
        vm.$refs.sidebarContact.scrollTop = 0

        setTimeout(() => {
          vm.onRefreshUsers()
        }, vm.refreshingTime)
      })
    },
    scrollUsers: function() {
      var vm = this
      var totalHeight =
        vm.$refs.sidebarContact.scrollTop + $(vm.$refs.sidebarContact).outerHeight(true)
      var usersHeight = $(vm.$refs.contact).outerHeight(true)

      vm.isUserTop = vm.$refs.sidebarContact.scrollTop == 0
      vm.isUserBottom = totalHeight == usersHeight

      if (vm.isUserTop) {
        vm.ableToUserLoadmore = true
        vm.offsetUserLoadmore = vm.limit
      }

      if (vm.isUserBottom && vm.ableToUserLoadmore) {
        if (vm.isUserLoadmore) {
          return false
        }
        vm.isUserLoadmore = true
        vm.getChatUsers(vm.offsetUserLoadmore, function(users) {
          if (users.length == 0) {
            vm.ableToUserLoadmore = false
          }
          for (let index = 0; index < users.length; index++) {
            vm.users.push(users[index])
            vm.checkingUsers[users[index].userid] = users[index]
            vm.checkingUsers[users[index].userid].haveNewMessage = false
          }
          vm.offsetUserLoadmore += vm.limit
          vm.$refs.sidebarContact.scrollTop = vm.$refs.sidebarContact.scrollTop - 100
          vm.isUserLoadmore = false
        })
      }
    },
    scrollChatlog: function() {
      var vm = this
      var totalHeight =
        vm.$refs.chatlogContainer.scrollTop + $(vm.$refs.chatlogContainer).outerHeight(true)
      var chatlogHeight =
        $(vm.$refs.chatlog).outerHeight(true) + $(vm.$refs.padding).outerHeight(true)

      vm.isBottom = chatlogHeight == totalHeight
      vm.ableToScroll = chatlogHeight > $(vm.$refs.chatlogContainer).outerHeight(true)

      if (vm.isBottom) {
        vm.ableToLoadmore = true
        vm.offsetLoadmore = vm.limit
      }

      vm.isTop = vm.$refs.chatlogContainer.scrollTop == 0
      if (vm.isTop && vm.ableToLoadmore) {
        if (vm.isLoadmore || vm.isSelecting) {
          return false
        }
        vm.isLoadmore = true
        vm.getChatlog(vm.offsetLoadmore, function(messages) {
          if (messages.length == 0) {
            vm.ableToLoadmore = false
          }
          for (let index = messages.length - 1; index >= 0; index--) {
            // console.log(messages[index])
            vm.messages.unshift(messages[index])
          }
          vm.offsetLoadmore += vm.limit
          vm.$refs.chatlogContainer.scrollTop = 100
          vm.isLoadmore = false
        })
      }
    },
    openSidebar: function() {
      this.showSidebar = true
      // alert(this.showSidebar)
    },
    onTyping: function() {
      this.scrollBottom()
      document.body.scrollTop = $(this).offset().top
    }
  },
  watch: {
    showSidebar: function() {
      var vm = this
      // vm.sidebarContactHeight = vm.getSidebarContactHeight()
    },
    'window.height': function() {
      var vm = this
      vm.chatlogHeight = vm.getChatlogHeight()
    }
  },
  beforeDestroy() {
    clearInterval(this.refreshMessages)
    clearInterval(this.refreshUsers)
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/chat/Chat.vue